/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ limit: NonNullable<unknown>, proLimit: NonNullable<unknown> }} Directory_Submit_Quota_ExhaustedInputs */

const en_directory_submit_quota_exhausted = /** @type {(inputs: Directory_Submit_Quota_ExhaustedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You've used all ${i?.limit} free submissions. Upgrade to Pro for ${i?.proLimit} submissions per month; the Sponsor plan is unlimited.`)
};

const zh_directory_submit_quota_exhausted = /** @type {(inputs: Directory_Submit_Quota_ExhaustedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你已用完 ${i?.limit} 次免费提交额度。升级到 Pro 每月可提交 ${i?.proLimit} 次；Sponsor 套餐不限次数。`)
};

/**
* | output |
* | --- |
* | "You've used all {limit} free submissions. Upgrade to Pro for {proLimit} submissions per month; the Sponsor plan is unlimited." |
*
* @param {Directory_Submit_Quota_ExhaustedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_quota_exhausted = /** @type {((inputs: Directory_Submit_Quota_ExhaustedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Quota_ExhaustedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_quota_exhausted(inputs)
	return zh_directory_submit_quota_exhausted(inputs)
});
export { directory_submit_quota_exhausted as "directory.submit.quota_exhausted" }